import { Button } from "plos/src/components/buttons/Button";
import { Sheet } from "plos/src/components/Sheet";
import InfoIcon from "plos/src/img/icons/info.svg?react";
import { copy } from "plos/src/styles";
import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { helpSheetContent } from "../../Tutorials/ContextualHelpSheet/contextualHelp.css";
import { priceChangePredictionEnabled } from "../utils";

const UnderstandingPriceChanges = () => {
  const { t } = useTranslation("priceChanges");

  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Button onPress={handleOpen} appearance="tonal" fullWidth size="small">
        <InfoIcon />
        {t("helpSheet.title", "Understanding Price Changes")}
      </Button>
      <Sheet
        headerSize="xl"
        title={t("helpSheet.title", "Understanding Price Changes")}
        open={open}
        handleClose={handleClose}
      >
        <div className={helpSheetContent}>
          <div className={copy}>
            {priceChangePredictionEnabled ? (
              <Trans ns="priceChanges" i18nKey="helpSheet.content2">
                <p>
                  The Price Changes page shows which players are moving towards
                  a possible price rise or fall at the next price change
                  deadline.
                </p>
                <p>
                  A countdown to the next potential update is shown above the
                  table. Each player’s status indicates how likely they are to
                  change in price.
                </p>
                <p>
                  Progress shows how far a player has currently moved towards a
                  price change. Predicted Progress estimates where they will be
                  by the time of the next update. When Predicted Progress
                  exceeds 100%, the player is considered Very Likely to rise or
                  fall.
                </p>
                <p>
                  Price change predictions are a guide, not a guarantee. Always
                  consider team news and the Gameweek deadline before making
                  transfers.
                </p>
              </Trans>
            ) : (
              <Trans ns="priceChanges" i18nKey="helpSheet.content1">
                <p>
                  The Price Changes page shows which players are moving towards
                  a possible price rise or fall at the next price change
                  deadline.
                </p>
                <p>
                  A countdown to the next potential update is shown above the
                  table. Each player’s status indicates how likely they are to
                  change in price at that deadline.
                </p>
                <p>
                  Progress indicates how far a player has moved towards a price
                  change. When it exceeds 100%, the player is considered Very
                  Likely to rise or fall.
                </p>
                <p>
                  Price change predictions are a guide, not a guarantee. Always
                  consider team news and the Gameweek deadline before making
                  transfers.
                </p>
              </Trans>
            )}
          </div>
        </div>
      </Sheet>
    </div>
  );
};

export default UnderstandingPriceChanges;
